import React from "react";
import DashboardLayout from "../components/dashboard/DashboardLayout";
import UserNavbar from "../components/navbar/UserNavbar";

const UserLayout = () => <DashboardLayout layout="/user" Navbar={UserNavbar} />;

export default UserLayout;
